module.exports = __webpack_public_path__ + "img/13-4.f23d0f41.png";